<div class="contenedor-promo">
  <div *ngIf="promotions.length == 0" class="fila-vertical"></div>
  <panel-promotion-item [ngClass]="promotions.length <= 1 ? 'fila-vertical':'fila-promo'"
    *ngFor="let promo of promotions; let i = index" [promotion]="promo" [promotionLenght]="promotions.length"
    [alertsLenght]="alerts.length" [promotionIndex]="i">
  </panel-promotion-item>
</div>